import React, { ReactNode } from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'light'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-64" data-mp="3jzx2rvg420na">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.16em] sm:text-sm ${dark ? 'text-gold' : 'text-brand-600'}`} data-id="element-65" data-mp="3k204hcqmli7u">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 font-display text-[30px] font-bold leading-[1.12] sm:text-5xl ${dark ? 'text-white' : 'text-ink'}`} data-id="element-66" data-mp="gi57a72rmykc">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-[17px] leading-relaxed sm:text-lg ${dark ? 'text-brand-100' : 'text-ink-soft'}`} data-id="element-67" data-mp="6slp73mvn8qj">
          {subtitle}
        </p>}
    </div>;
}